import Vue from 'vue'
import Vuex from 'vuex'
import api from '../tools/api'
// import patch from '../tools/patch'

Vue.use(Vuex)

const Store = {
  state: {
    connected: false,
    sports: {},
    federations: {},
    categories: {},
    regions: {},
    places: {},
    placeResults: {
      totalItems: 0,
      items: []
    },
    clubs: {},
    clubResults: {
      totalItems: 0,
      items: []
    },
    teams: {},
    teamResults: {
      totalItems: 0,
      items: []
    },
    competitions: {},
    competitionResults: {
      totalItems: 0,
      items: []
    },
    matches: {},
    matchResults: {
      totalItems: 0,
      items: []
    },
    videos: {},
    videoResults: {
      totalItems: 0,
      items: []
    },
    users: {},
    userResults: {
      totalItems: 0,
      items: []
    },
    notifications: {},
    notificationResults: {
      totalItems: 0,
      items: []
    },
    topActions: {},
    topActionResults: {
      totalItems: 0,
      items: []
    },
    clips: {},
    clipsResults: {
      totalItems: 0,
      items: []
    }
  },
  mutations: {
    //
    // CONNEXION
    //

    SET_CONNECTED (state, token) {
      api.setConnected(token)
      state.connected = true
    },

    SET_DISCONNECTED (state) {
      state.connected = false
    },

    //
    // SPORTS
    //

    SET_SPORT (state, sport) {
      Vue.set(state.sports, sport.id, sport)
    },

    SET_SPORTS (state, sports) {
      for (const sport of sports) {
        Vue.set(state.sports, sport.id, sport)
      }
    },

    REMOVE_SPORT (state, id) {
      Vue.delete(state.sports, id)
    },

    CLEAR_SPORTS (state) {
      state.sports = {}
    },

    //
    // FEDERATIONS
    //

    SET_FEDERATION (state, federation) {
      Vue.set(state.federations, federation.id, federation)
    },

    SET_FEDERATIONS (state, federations) {
      for (const federation of federations) {
        Vue.set(state.federations, federation.id, federation)
      }
    },

    REMOVE_FEDERATION (state, id) {
      Vue.delete(state.federations, id)
    },

    CLEAR_FEDERATIONS (state) {
      state.federations = {}
    },

    //
    // CATEGORIES
    //

    SET_CATEGORY (state, category) {
      Vue.set(state.categories, category.id, category)
    },

    SET_CATEGORIES (state, categories) {
      for (const category of categories) {
        Vue.set(state.categories, category.id, category)
      }
    },

    REMOVE_CATEGORY (state, id) {
      Vue.delete(state.categories, id)
    },

    CLEAR_CATEGORIES (state) {
      state.categories = {}
    },

    //
    // REGIONS
    //

    SET_REGION (state, {parentID, region}) {
      const setRegion = (r) => {
        Vue.set(state.regions, r.id, r)
        for (const sub of r.subregions) {
          setRegion(sub)
        }
      }
      setRegion(region)
      if (parentID) {
        const parent = state.regions[parentID]
        if (!parent.subregions.find(r => r.id === region.id)) {
          parent.subregions.push(region)
        }
      }
    },

    REMOVE_REGION (state, id) {
      Vue.delete(state.regions, id)
    },

    CLEAR_REGIONS (state) {
      state.regions = {}
    },

    //
    // PLACES
    //

    SET_PLACE (state, place) {
      Vue.set(state.places, place.id, place)

      for (const i in state.placeResults.items) {
        if (place.id === state.placeResults.items[i].id) {
          Vue.set(state.placeResults.items, i, place)
        }
      }
    },

    SET_PLACES (state, places) {
      for (const place of places) {
        Vue.set(state.places, place.id, place)

        for (const i in state.placeResults.items) {
          if (place.id === state.placeResults.items[i].id) {
            Vue.set(state.placeResults.items, i, place)
          }
        }
      }
    },

    SET_PLACE_RESULTS (state, results) {
      state.placeResults = results
      for (const place of results.items) {
        Vue.set(state.places, place.id, place)
      }
    },

    REMOVE_PLACE (state, id) {
      Vue.delete(state.places, id)
      state.placeResults.totalItems--
    },

    CLEAR_PLACES (state) {
      state.places = {}
    },

    CLEAR_PLACE_RESULTS (state) {
      Vue.set(state.placeResults, 'totalItems', 0)
      Vue.set(state.placeResults, 'items', [])
    },

    //
    // CLUBS
    //

    SET_CLUB (state, club) {
      Vue.set(state.clubs, club.id, club)

      for (const i in state.clubResults.items) {
        if (club.id === state.clubResults.items[i].id) {
          Vue.set(state.clubResults.items, i, club)
        }
      }
    },

    SET_CLUBS (state, clubs) {
      for (const club of clubs) {
        Vue.set(state.clubs, club.id, club)

        for (const i in state.clubResults.items) {
          if (club.id === state.clubResults.items[i].id) {
            Vue.set(state.clubResults.items, i, club)
          }
        }
      }
    },

    SET_CLUB_RESULTS (state, results) {
      state.clubResults = results
      for (const club of results.items) {
        Vue.set(state.clubs, club.id, club)
      }
    },

    REMOVE_CLUB (state, id) {
      Vue.delete(state.clubs, id)
      state.clubResults.totalItems--
    },

    CLEAR_CLUBS (state) {
      state.clubs = {}
    },

    CLEAR_CLUB_RESULTS (state) {
      Vue.set(state.clubResults, 'totalItems', 0)
      Vue.set(state.clubResults, 'items', [])
    },

    //
    // TEAMS
    //

    SET_TEAM (state, team) {
      Vue.set(state.teams, team.id, team)

      for (const i in state.teamResults.items) {
        if (team.id === state.teamResults.items[i].id) {
          Vue.set(state.teamResults.items, i, team)
        }
      }
    },

    SET_TEAMS (state, teams) {
      for (const team of teams) {
        Vue.set(state.teams, team.id, team)

        for (const i in state.teamResults.items) {
          if (team.id === state.teamResults.items[i].id) {
            Vue.set(state.teamResults.items, i, team)
          }
        }
      }
    },

    SET_TEAM_RESULTS (state, results) {
      state.teamResults = results
      for (const team of results.items) {
        Vue.set(state.teams, team.id, team)
      }
    },

    REMOVE_TEAM (state, id) {
      Vue.delete(state.teams, id)
      state.teamResults.totalItems--
    },

    CLEAR_TEAMS (state) {
      state.teams = {}
    },

    CLEAR_TEAM_RESULTS (state) {
      Vue.set(state.teamResults, 'totalItems', 0)
      Vue.set(state.teamResults, 'items', [])
    },

    //
    // COMPETITIONS
    //

    SET_COMPETITION (state, competition) {
      Vue.set(state.competitions, competition.id, competition)

      for (const i in state.competitionResults.items) {
        if (competition.id === state.competitionResults.items[i].id) {
          Vue.set(state.competitionResults.items, i, competition)
        }
      }
    },

    SET_COMPETITIONS (state, competitions) {
      for (const competition of competitions) {
        Vue.set(state.competitions, competition.id, competition)

        for (const i in state.competitionResults.items) {
          if (competition.id === state.competitionResults.items[i].id) {
            Vue.set(state.competitionResults.items, i, competition)
          }
        }
      }
    },

    SET_COMPETITION_RESULTS (state, results) {
      state.competitionResults = results
      for (const competition of results.items) {
        Vue.set(state.competitions, competition.id, competition)
      }
    },

    REMOVE_COMPETITION (state, id) {
      Vue.delete(state.competitions, id)
      state.competitionResults.totalItems--
    },

    CLEAR_COMPETITION (state) {
      state.competitions = {}
    },

    CLEAR_COMPETITION_RESULTS (state) {
      Vue.set(state.competitionResults, 'totalItems', 0)
      Vue.set(state.competitionResults, 'items', [])
    },

    //
    // MATCHES
    //

    SET_MATCH (state, match) {
      Vue.set(state.matches, match.id, match)

      for (const i in state.matchResults.items) {
        if (match.id === state.matchResults.items[i].id) {
          Vue.set(state.matchResults.items, i, match)
        }
      }
    },

    SET_MATCHES (state, matches) {
      for (const match of matches) {
        Vue.set(state.matches, match.id, match)

        for (const i in state.matchResults.items) {
          if (match.id === state.matchResults.items[i].id) {
            Vue.set(state.matchResults.items, i, match)
          }
        }
      }
    },

    SET_MATCH_RESULTS (state, results) {
      state.matchResults = results
      for (const match of results.items) {
        Vue.set(state.matches, match.id, match)
      }
    },

    REMOVE_MATCH (state, id) {
      Vue.delete(state.matches, id)
      state.matchResults.totalItems--
    },

    CLEAR_MATCHES (state) {
      state.matches = {}
    },

    CLEAR_MATCH_RESULTS (state) {
      Vue.set(state.matchResults, 'totalItems', 0)
      Vue.set(state.matchResults, 'items', [])
    },

    //
    // VIDEOS
    //

    SET_VIDEO (state, video) {
      Vue.set(state.videos, video.id, video)

      for (const i in state.videoResults.items) {
        if (video.id === state.videoResults.items[i].id) {
          Vue.set(state.videoResults.items, i, video)
        }
      }
    },

    SET_VIDEOS (state, videos) {
      for (const video of videos) {
        Vue.set(state.videos, video.id, video)

        for (const i in state.videoResults.items) {
          if (video.id === state.videoResults.items[i].id) {
            Vue.set(state.videoResults.items, i, video)
          }
        }
      }
    },

    SET_VIDEO_RESULTS (state, results) {
      state.videoResults = results
      for (const video of results.items) {
        Vue.set(state.videos, video.id, video)
      }
    },

    REMOVE_VIDEO (state, id) {
      Vue.delete(state.videos, id)
      state.videoResults.totalItems--
    },

    CLEAR_VIDEOS (state) {
      state.videos = {}
    },

    CLEAR_VIDEO_RESULTS (state) {
      Vue.set(state.videoResults, 'totalItems', 0)
      Vue.set(state.videoResults, 'items', [])
    },

    //
    // USERS
    //

    SET_USER (state, user) {
      Vue.set(state.users, user.id, user)

      for (const i in state.userResults.items) {
        if (user.id === state.userResults.items[i].id) {
          Vue.set(state.userResults.items, i, user)
        }
      }
    },

    SET_USERS (state, users) {
      for (const user of users) {
        Vue.set(state.users, user.id, user)

        for (const i in state.userResults.items) {
          if (user.id === state.userResults.items[i].id) {
            Vue.set(state.userResults.items, i, user)
          }
        }
      }
    },

    SET_USER_RESULTS (state, results) {
      state.userResults = results
      for (const user of results.items) {
        Vue.set(state.users, user.id, user)
      }
    },

    REMOVE_USER (state, id) {
      Vue.delete(state.users, id)
      state.userResults.totalItems--
    },

    CLEAR_USERS (state) {
      state.users = {}
    },

    CLEAR_USER_RESULTS (state) {
      Vue.set(state.userResults, 'totalItems', 0)
      Vue.set(state.userResults, 'items', [])
    },

    //
    // NOTIFICATIONS
    //

    SET_NOTIFICATION (state, notif) {
      Vue.set(state.notifications, notif.id, notif)

      for (const i in state.notificationResults.items) {
        if (notif.id === state.notificationResults.items[i].id) {
          Vue.set(state.notificationResults.items, i, notif)
        }
      }
    },

    SET_NOTIFICATIONS (state, notifications) {
      for (const notif of notifications) {
        Vue.set(state.notifications, notif.id, notif)

        for (const i in state.notificationResults.items) {
          if (notif.id === state.notificationResults.items[i].id) {
            Vue.set(state.notificationResults.items, i, notif)
          }
        }
      }
    },

    //
    // TOPACTIONS
    //

    SET_TOPACTION (state, topAction) {
      Vue.set(state.topActions, topAction.id, topAction)

      for (const i in state.topActionResults.items) {
        if (topAction.id === state.topActionResults.items[i].id) {
          Vue.set(state.topActionResults.items, i, topAction)
        }
      }
    },

    SET_TOPACTIONS (state, topActions) {
      for (const topAction of topActions) {
        Vue.set(state.topActions, topAction.id, topAction)

        for (const i in state.topActionResults.items) {
          if (topAction.id === state.topActionResults.items[i].id) {
            Vue.set(state.topActionResults.items, i, topAction)
          }
        }
      }
    },

    SET_TOPACTION_RESULTS (state, results) {
      state.topActionResults = results
      for (const topAction of results.items) {
        Vue.set(state.topActions, topAction.id, topAction)
      }
    },

    REMOVE_TOPACTION (state, id) {
      Vue.delete(state.topActions, id)
      state.topActionResults.totalItems--
    },

    CLEAR_TOPACTIONS (state) {
      state.topActions = {}
    },

    CLEAR_TOPACTION_RESULTS (state) {
      Vue.set(state.topActionResults, 'totalItems', 0)
      Vue.set(state.topActionResults, 'items', [])
    },

    //
    // CLIPS
    //

    SET_CLIP (state, clip) {
      Vue.set(state.clips, clip.id, clip)

      for (const i in state.clipResults) {
        if (clip.id === state.clipResults[i].id) {
          Vue.set(state.clipResults, i, clip)
        }
      }
    },

    SET_CLIP_RESULTS (state, results) {
      state.clipResults = results
      for (const clip of results) {
        Vue.set(state.clips, clip.id, clip)
      }
    },

    REMOVE_CLIP (state, id) {
      Vue.delete(state.clips, id)
      state.clipResults.totalItems--
    }

  },
  getters: {
    sportValues: state => Object.values(state.sports),
    federationValues: state => Object.values(state.federations),
    categoryValues: state => Object.values(state.categories),
    regionValues: state => Object.values(state.regions),
    placeValues: state => Object.values(state.places),
    competitionValues: state => Object.values(state.competitions),
    clubValues: state => Object.values(state.clubs),
    teamValues: state => Object.values(state.teams),
    matchValues: state => Object.values(state.matches),
    matchByIDs: state => ids => Object.values(state.matches).filter(m => ids.indexOf(m.id) !== -1),
    videoValues: state => Object.values(state.videos),
    videoByIDs: state => ids => Object.values(state.videos).filter(v => ids.indexOf(v.id) !== -1),
    userValues: state => Object.values(state.users),
    userByIDs: state => ids => Object.values(state.users).filter(v => ids.indexOf(v.id) !== -1),
    notificationValues: state => Object.values(state.notifications),
    notificationByIDs: state => ids => Object.values(state.notifications).filter(n => ids.indexOf(n.id) !== -1),
    topActionValues: state => Object.values(state.topActions),
    topActionByIDs: state => ids => Object.values(state.topActions).filter(v => ids.indexOf(v.id) !== -1),
    clipValues: state => Object.values(state.clips),
    clipsByIDs: state => ids => Object.values(state.clips).filter(c => ids.indexOf(c.id) !== -1)
  },
  actions: {

    //
    // Connexion
    //

    login ({commit}, {username, password}) {
      return api.login(username, password)
        .then(user => {
          if (
            user.signInUserSession.accessToken.payload['cognito:groups'] &&
            user.signInUserSession.accessToken.payload['cognito:groups'].includes('Admin')
          ) {
            commit('SET_CONNECTED', user.signInUserSession.idToken.jwtToken)
            return user
          } else {
            return api.disconnect()
              .then(() => {
                commit('SET_DISCONNECTED')
              })
          }
        })
    },

    disconnect ({commit}) {
      return api.disconnect()
        .then(() => {
          commit('SET_DISCONNECTED')
        })
    },

    //
    // Sports
    //

    createSport ({commit}, sport) {
      return api.createSport(sport)
        .then(resp => {
          sport.id = resp.data.id
          commit('SET_SPORT', sport)
          return sport
        })
    },

    getSports ({commit}) {
      return api.fetchSports()
        .then(resp => {
          commit('SET_SPORTS', resp.data)
          return resp.data
        })
    },

    getSport ({commit}, id) {
      return api.getSport(id)
        .then(resp => {
          commit('SET_SPORT', resp.data)
          return resp.data
        })
    },

    patchSport ({dispatch}, {id, patch}) {
      return api.patchSport(id, patch)
        .then(() => dispatch('getSport', id))
    },

    deleteSport ({commit}, id) {
      return api.deleteSport(id)
        .then(() => {
          commit('REMOVE_SPORT', id)
        })
    },

    //
    // Federations
    //

    createFederation ({commit}, {sportID, federation}) {
      return api.createFederation(sportID, federation)
        .then(resp => {
          federation.id = resp.data.id
          commit('SET_FEDERATION', federation)
          return federation
        })
    },

    getSportFederations ({commit}, sportID) {
      return api.getSportFederations(sportID)
        .then(resp => {
          commit('SET_FEDERATIONS', resp.data)
          return resp.data
        })
    },

    getFederation ({commit}, id) {
      return api.getFederation(id)
        .then(resp => {
          commit('SET_FEDERATION', resp.data)
          return resp.data
        })
    },

    patchFederation ({dispatch}, {id, patch}) {
      return api.patchFederation(id, patch)
        .then(() => dispatch('getFederation', id))
    },

    deleteFederation ({commit}, id) {
      return api.deleteFederation(id)
        .then(() => {
          commit('REMOVE_FEDERATION', id)
        })
    },

    clearFederations ({commit}) {
      commit('CLEAR_FEDERATIONS')
    },

    //
    // Categories
    //

    createCategory ({commit}, {federationID, category}) {
      return api.createCategory(federationID, category)
        .then(resp => {
          category.id = resp.data.id
          commit('SET_CATEGORY', category)
          return category
        })
    },

    getFederationCategories ({commit}, federationID) {
      return api.getFederationCategories(federationID)
        .then(resp => {
          commit('SET_CATEGORIES', resp.data)
          return resp.data
        })
    },

    getCategory ({commit}, id) {
      return api.getCategory(id)
        .then(resp => {
          commit('SET_CATEGORY', resp.data)
          return resp.data
        })
    },

    deleteCategory ({commit}, id) {
      return api.deleteCategory(id)
        .then(() => {
          commit('REMOVE_CATEGORY', id)
        })
    },

    //
    // Regions
    //

    createSubregion ({commit}, {parentID, region}) {
      return api.createSubregion(parentID, region)
        .then(resp => {
          region.id = resp.data.id
          commit('SET_REGION', {parentID, region})
          return region
        })
    },

    getFederationRegions ({commit}, federationID) {
      return api.getFederationRegions(federationID)
        .then(resp => {
          commit('SET_REGION', {region: resp.data})
          return resp.data
        })
    },

    getRegion ({commit}, id) {
      return api.getRegion(id)
        .then(resp => {
          commit('SET_REGION', {region: resp.data})
          return resp.data
        })
    },

    deleteRegion ({commit}, id) {
      return api.deleteRegion(id)
        .then(() => {
          commit('REMOVE_REGION', id)
        })
    },

    //
    // Places
    //

    createPlace ({commit}, place) {
      return api.createPlace(place)
        .then(resp => {
          place.id = resp.data.id
          commit('SET_PLACE', place)
          return place
        })
    },

    fetchPlaces ({commit}, params) {
      return api.fetchPlaces(params)
        .then(resp => {
          commit('SET_PLACE_RESULTS', resp.data)
          return resp.data
        })
    },

    searchPlaces ({commit}, params) {
      if (params.id) {
        return api.getPlace(params.id)
          .then(resp => {
            commit('SET_PLACE_RESULTS', {
              items: [
                resp.data
              ],
              totalItems: 1
            })
            return resp.data
          })
      } else {
        return api.searchPlaces(params)
          .then(resp => {
            commit('SET_PLACE_RESULTS', resp.data)
            return resp.data
          })
      }
    },

    getPlace ({commit}, id) {
      return api.getPlace(id)
        .then(resp => {
          commit('SET_PLACE', resp.data)
          return resp.data
        })
    },

    patchPlace ({dispatch}, {id, patch}) {
      return api.patchPlace(id, patch)
        .then(() => dispatch('getPlace', id))
    },

    deletePlace ({commit}, {id}) {
      return api.deletePlace(id)
        .then(() => {
          commit('REMOVE_PLACE', id)
        })
    },

    //
    // Clubs
    //

    createClub ({commit}, club) {
      return api.createClub(club)
        .then(resp => {
          club.id = resp.data.id
          commit('SET_CLUB', club)
          return club
        })
    },

    fetchClubs ({commit}, params) {
      return api.fetchClubs(params)
        .then(resp => {
          commit('SET_CLUB_RESULTS', resp.data)
          return resp.data
        })
    },

    searchClubs ({commit}, params) {
      return api.searchClubs(params)
        .then(resp => {
          commit('SET_CLUB_RESULTS', resp.data)
          return resp.data
        })
    },

    getClub ({commit}, id) {
      return api.getClub(id)
        .then(resp => {
          commit('SET_CLUB', resp.data)
          return resp.data
        })
    },

    patchClub ({dispatch}, {id, patch}) {
      return api.patchClub(id, patch)
        .then(() => dispatch('getClub', id))
    },

    deleteClub ({commit}, id) {
      return api.deleteClub(id)
        .then(() => {
          commit('REMOVE_CLUB', id)
        })
    },

    confirmDeleteClub ({commit}, id) {
      return api.confirmDeleteClub(id)
        .then(() => {
          commit('REMOVE_CLUB', id)
        })
    },

    uploadClubLogo ({commit}, params) {
      return api.uploadClubLogo(params)
        .then(resp => {
          return resp
        })
    },

    //
    // Teams
    //

    createTeam ({commit}, team) {
      return api.createTeam(team)
        .then(resp => {
          team.id = resp.data.id
          commit('SET_TEAM', team)
          return team
        })
    },

    fetchTeams ({commit}, params) {
      return api.fetchTeams(params)
        .then(resp => {
          commit('SET_TEAM_RESULTS', resp.data)
          return resp.data
        })
    },

    searchTeams ({commit}, params) {
      return api.searchTeams(params)
        .then(resp => {
          commit('SET_TEAM_RESULTS', resp.data)
          return resp.data
        })
    },

    getTeam ({commit}, id) {
      return api.getTeam(id)
        .then(resp => {
          commit('SET_TEAM', resp.data)
          return resp.data
        })
    },

    patchTeam ({dispatch}, {id, patch}) {
      return api.patchTeam(id, patch)
        .then(() => dispatch('getTeam', id))
    },

    deleteTeam ({commit}, id) {
      return api.deleteTeam(id)
        .then(() => {
          commit('REMOVE_TEAM', id)
        })
    },

    confirmDeleteTeam ({commit}, id) {
      return api.confirmDeleteTeam(id)
        .then(() => {
          commit('REMOVE_TEAM', id)
        })
    },

    //
    // Competitions
    //

    createCompetition ({commit}, competition) {
      return api.createCompetition(competition)
        .then(resp => {
          competition.id = resp.data.id
          commit('SET_COMPETITION', competition)
          return competition
        })
    },

    fetchCompetitions ({commit}, params) {
      return api.fetchCompetitions(params)
        .then(resp => {
          commit('SET_COMPETITION_RESULTS', resp.data)
          return resp.data
        })
    },

    searchCompetitions ({commit}, params) {
      return api.searchCompetitions(params)
        .then(resp => {
          commit('SET_COMPETITION_RESULTS', resp.data)
          return resp.data
        })
    },

    getCompetition ({commit}, id) {
      return api.getCompetition(id)
        .then(resp => {
          commit('SET_COMPETITION', resp.data)
          return resp.data
        })
    },

    patchCompetition ({dispatch}, {id, patch}) {
      return api.patchCompetition(id, patch)
        .then(() => dispatch('getCompetition', id))
    },

    deleteCompetition ({commit}, id) {
      return api.deleteCompetition(id)
        .then(() => {
          commit('REMOVE_COMPETITION', id)
        })
    },

    uploadCompetitionLogo ({commit}, params) {
      return api.uploadCompetitionLogo(params)
    },

    //
    // Matches
    //

    createMatch ({dispatch}, match) {
      return api.createMatch(match)
        .then(resp => dispatch('getMatch', resp.data.id))
    },

    fetchMatches ({commit}, params) {
      return api.fetchMatches(params)
        .then(resp => {
          commit('SET_MATCH_RESULTS', resp.data)
          return resp.data
        })
    },

    searchMatches ({commit}, params) {
      return api.searchMatches(params)
        .then(resp => {
          commit('SET_MATCH_RESULTS', resp.data)
          return resp.data
        })
    },

    getMatch ({commit}, id) {
      return api.getMatch(id)
        .then(resp => {
          commit('SET_MATCH', resp.data)
          return resp.data
        })
    },

    patchMatch ({dispatch}, {id, patch}) {
      return api.patchMatch(id, patch)
        .then(() => dispatch('getMatch', id))
    },

    deleteMatch ({commit}, id) {
      return api.deleteMatch(id)
        .then(() => {
          commit('REMOVE_MATCH', id)
        })
    },

    confirmDeleteMatch ({commit}, id) {
      return api.confirmDeleteMatch(id)
        .then(() => {
          commit('REMOVE_MATCH', id)
        })
    },

    privatizeMatchVideos ({commit}, params) {
      return api.privatizeMatchVideos(params)
    },

    //
    // Videos
    //

    fetchVideos ({commit}, params) {
      return api.fetchVideos(params)
        .then(resp => {
          commit('SET_VIDEO_RESULTS', resp.data)
          return resp.data
        })
    },

    searchVideos ({commit}, params) {
      return api.searchVideos(params)
        .then(resp => {
          commit('SET_VIDEO_RESULTS', resp.data)
          return resp.data
        })
    },

    getVideo ({commit}, id) {
      return api.getVideo(id)
        .then(resp => {
          commit('SET_VIDEO', resp.data)
          return resp.data
        })
    },

    patchVideo ({dispatch}, {id, patch}) {
      return api.patchVideo(id, patch)
        .then(() => dispatch('getVideo', id))
    },

    deleteVideo ({commit}, id) {
      return api.deleteVideo(id)
        .then(() => {
          commit('REMOVE_VIDEO', id)
        })
    },

    hitVideo ({commit}, id) {
      return api.hitVideo(id)
    },

    suspendVideo ({commit}, id) {
      return api.suspendVideo(id)
    },

    suspendMatchVideos ({commit}, id) {
      return api.suspendMatchVideos(id)
    },

    unsuspendVideo ({commit}, id) {
      return api.unsuspendVideo(id)
    },

    unsuspendMatchVideos ({commit}, matchID) {
      return api.unsuspendMatchVideos(matchID)
    },

    //
    // Users
    //

    fetchUsers ({commit}, params) {
      return api.fetchUsers(params)
        .then(resp => {
          commit('SET_USER_RESULTS', resp.data)
          return resp.data
        })
    },

    searchUsers ({commit}, params) {
      return api.searchUsers(params)
        .then(resp => {
          commit('SET_USER_RESULTS', resp.data)
          return resp.data
        })
    },

    getUser ({commit}, id) {
      return api.getUser(id)
        .then(resp => {
          commit('SET_USER', resp.data)
          return resp.data
        })
    },

    // patchUser ({dispatch}, {id, patch}) {
    //   return api.patchUser(id, patch)
    //     .then(() => dispatch('getUser', id))
    // },

    deleteUser ({commit}, params) {
      return api.deleteUser(params)
        .then(resp => {
          commit('REMOVE_USER', params.id)
          return resp
        })
    },

    setUserPremium ({commit}, id) {
      return api.setUserPremium(id)
        .then(resp => {
          console.log(resp)
          return resp
        })
    },

    unsetUserPremium ({commit}, id) {
      return api.unsetUserPremium(id)
        .then(resp => {
          console.log(resp)
          return resp
        })
    },

    notifyUser (_, {id, notification}) {
      return api.notifyUser(id, notification)
    },

    notifyGroup (_, {topic, notification}) {
      return api.notifyGroup(topic, notification)
    },

    //
    // Notifications
    //

    createNotification ({commit}, notif) {
      return api.createNotification(notif)
        .then(resp => {
          return resp.data
        })
    },

    sendNotification ({commit}, notif) {
      return api.sendNotification(notif)
        .then(resp => {
          return resp.data
        })
    },

    fetchNotifications ({commit}) {
      return api.fetchNotifications()
        .then(resp => {
          commit('SET_NOTIFICATIONS', resp.data)
          return {
            totalItems: resp.data.length,
            items: resp.data
          }
        })
    },

    fetchAllNotifications ({commit}) {
      return api.fetchAllNotifications()
        .then(resp => {
          commit('SET_NOTIFICATIONS', resp.data)
          return {
            totalItems: resp.data.length,
            items: resp.data
          }
        })
    },

    getNotification ({commit}, {id}) {
      return api.getNotification(id)
        .then(resp => {
          commit('SET_NOTIFICATION', resp.data)
          return resp.data
        })
    },

    patchNotification ({dispatch}, {id, patch}) {
      return api.patchNotification(id, patch)
        .then(() => dispatch('getNotification', {id}))
    },

    //
    // Top Actions
    //

    createTopAction ({dispatch}, topAction) {
      return api.createTopAction(topAction)
        .then(resp => dispatch('getTopAction', resp.data.id))
    },

    fetchTopActions ({commit}, params) {
      return api.fetchTopActions(params)
        .then(resp => {
          commit('SET_TOPACTION_RESULTS', resp.data)
          return resp.data
        })
    },

    searchTopActions ({commit}, params) {
      return api.searchTopActions(params)
        .then(resp => {
          commit('SET_TOPACTION_RESULTS', resp.data)
          return resp.data
        })
    },

    getTopAction ({commit}, id) {
      return api.getTopAction(id)
        .then(resp => {
          commit('SET_TOPACTION', resp.data)
          return resp.data
        })
    },

    deleteTopAction ({commit}, id) {
      return api.deleteTopAction(id)
        .then(() => {
          commit('REMOVE_TOPACTION', id)
        })
    },

    //
    // Clips
    //

    searchClips ({commit}, params) {
      return api.searchClips(params)
        .then(resp => {
          commit('SET_CLIP_RESULTS', resp.data)
          return resp.data
        })
    },

    getClip ({commit}, id) {
      return api.getClip(id)
        .then(resp => {
          commit('SET_CLIP', resp.data)
          return resp.data
        })
    },

    patchClip ({dispatch}, {id, patch}) {
      return api.patchClip(id, patch)
        .then(() => dispatch('getClip', id))
    },

    deleteClip ({commit}, id) {
      return api.deleteClip(id)
        .then(() => {
          commit('REMOVE_CLIP', id)
        })
    }
  }
}

/* eslint-disable no-new */
export default new Vuex.Store(Store)



// WEBPACK FOOTER //
// ./src/store/index.js